import {
  SocialActionEnum,
  useControllerSocialMediaContext
} from '../../hooks/ControllerSocialMedia';

import Icon from '../Icon/Icon';
import './SocialMedia.scss';

import Button from '../Button/Button';
import {
  isSocialRecoveryFlow,
  pushGtmEvent,
  saveSocialFlowPath
} from '../../utils/GenericFunctions';

interface ButtonMicrosoftProps {
  action?: SocialActionEnum;
  showText?: boolean;
}

export default function ButtonMicrosoft({
  action,
  showText = false
}: ButtonMicrosoftProps) {
  const { redirectMicrosoft } = useControllerSocialMediaContext();

  function handleLoginMicrosoft() {
    if (isSocialRecoveryFlow()) {
      pushGtmEvent('recovery_social_click', { provider: 'microsoft' });
    }
    saveSocialFlowPath();
    redirectMicrosoft(action);
  }

  return (
    <Button
      customColors="btn-neutral"
      id="microsoft-btn"
      data-testid="btn-microsoft"
      aria-label="Entrar com Microsoft"
      onClick={handleLoginMicrosoft}
    >
      <Icon name="logoMicrosoft" />
      {showText && 'Continuar com Microsoft'}
    </Button>
  );
}
